/** @format */
/* eslint @typescript-eslint/await-thenable: "warn", @typescript-eslint/dot-notation: "warn" -- Legacy code: do not use as an example. */
/*
 * Base font size of the document.
 * The default font size of the document root
 */
const DEFAULT_ROOT_FONT_SIZE = 10;
/**
 * Base font size of the document root.
 *
 * The document root font size needs to be worked out per client, to be able to convert
 * REM units into pixels and vice versa, as this can be changed by the user in the browser settings.
 */
const baseFontSize = (() => {
    if (typeof window === 'undefined') {
        return DEFAULT_ROOT_FONT_SIZE;
    }

    const styles = window.getComputedStyle(document.documentElement);
    // TOUCH AND CHANGE:
    // eslint-disable-next-line @typescript-eslint/prefer-regexp-exec -- Legacy code: do not use as an example.
    const fontSize = styles.getPropertyValue('font-size').match(/\d+/);

    if (fontSize === null) {
        return DEFAULT_ROOT_FONT_SIZE;
    }

    return Number(fontSize[0]);
})();
/**
 * Converts a rem value into pixels
 *
 * @param rem The rem value to convert to pixels. E.g '1.2rem'
 * @returns {number} The number of pixels that the value is equivalent to
 */

export function convertRemToPixels(rem: string): number {
    const number = parseFloat(rem);
    return number * baseFontSize;
}
